export default __webpack_public_path__ + "static/media/ZingConect.9ac9cebd.png";